export default "__VITE_ASSET__b04e4bbd__"